<script>
    export let size = 32
    export let color = '#ffffff'
    export let style = ''
    export let title = null
</script>

<svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {style}
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.3332 8.53353L23.4666 6.66699L15.9998 14.1338L8.53305 6.66699L6.6665 8.53353L14.1333 16.0003L6.6665 23.4671L8.53305 25.3337L15.9998 17.8669L23.4666 25.3337L25.3332 23.4671L17.8664 16.0003L25.3332 8.53353Z"
        fill={color}
    ></path>
    <!-- <mask
        id="mask0_7887_296375"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="20"
        height="20"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.3332 8.53353L23.4666 6.66699L15.9998 14.1338L8.53305 6.66699L6.6665 8.53353L14.1333 16.0003L6.6665 23.4671L8.53305 25.3337L15.9998 17.8669L23.4666 25.3337L25.3332 23.4671L17.8664 16.0003L25.3332 8.53353Z"
            fill={color}
        />
    </mask>
    <g mask="url(#mask0_7887_296375)">
        <rect width="32" height="32" fill={color} />
    </g> -->
</svg>
